import React, {FC} from 'react';
import styled from 'styled-components';
import {palette, mediaQueryMixins, menuBreakpoint} from '../../../../../lib/styleVariables';
import {StyledMenuItem, MobileHeaderMenuPrimaryItem} from '../mobileHeaderMenuPrimaryItem';
import {PrimaryLink, SecondaryLink} from '../../../../molecules/buttonsR4';
import {HeaderMenuProps} from '../headerMenuTypes';
import {rightMenuButtonStyle} from '.';
import {paletteR4} from '../../../../../lib/styleVariablesR4';

interface HeaderExpandMobileMenuProps {
  leftNav: HeaderMenuProps['leftNav'];
  rightNav: HeaderMenuProps['rightNav'];
  primaryItem: HeaderMenuProps['primaryItem'];
  secondaryItem: HeaderMenuProps['secondaryItem'];
  locationPath: string;
}

const StyledExpandedMobilMenu = styled.div`
  display: none;
  overflow: auto;
  flex-direction: column;
  width: 100%;
  padding: 16px 32px 40px;
  flex-grow: 1;
  ${mediaQueryMixins.maxWidth(`${menuBreakpoint}px`)} {
    display: flex;
  }
`;

const StyledRightMenuPrimaryButtonMobileWrapper = styled.div`
  margin-top: auto;
  padding-top: 40px;

  ${mediaQueryMixins.maxWidth(`${menuBreakpoint}px`)} {
    background: ${paletteR4.white.base};
    [data-theme='dark'] & {
      background: ${palette.black.base};
    }
  }
`;

const StyledPrimaryLink = styled(PrimaryLink)`
  ${rightMenuButtonStyle}
`;

const StyledSecondaryLink = styled(SecondaryLink)`
  ${rightMenuButtonStyle}
  ${mediaQueryMixins.maxWidth(`${menuBreakpoint}px`)} {
    margin-top: 16px;
  }
`;

const StyledMenuItemWrapper = styled.div`
  border-bottom: 1px solid ${paletteR4.dark_blue.base};
`;

export const HeaderExpandMobileMenu: FC<HeaderExpandMobileMenuProps> = props => (
  <StyledExpandedMobilMenu>
    {props.leftNav.map(item => (
      <MobileHeaderMenuPrimaryItem item={item} locationPath={props.locationPath} key={item.name} />
    ))}
    {props.rightNav.map(item => (
      <StyledMenuItemWrapper>
        <StyledMenuItem key={item.name} href={item.href}>
          {item.name}
        </StyledMenuItem>
      </StyledMenuItemWrapper>
    ))}
    <StyledRightMenuPrimaryButtonMobileWrapper>
      <StyledPrimaryLink href={props.primaryItem.href}>{props.primaryItem.name}</StyledPrimaryLink>
      {props.secondaryItem.href && props.secondaryItem.name && (
        <StyledSecondaryLink href={props.secondaryItem.href}>{props.secondaryItem.name}</StyledSecondaryLink>
      )}
    </StyledRightMenuPrimaryButtonMobileWrapper>
  </StyledExpandedMobilMenu>
);
